/* eslint-disable */
import React, { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { useAppSelector } from "@redux/hooks";
import { useAuth0 } from "@auth0/auth0-react";
import GenericModal from "@ui-components/Modal/GenericModal";
import GenericInput from "@ui-components/Input/GenericInput";
import GenericButton from "@ui-components/Button/GenericButton";
import { useProcessingOverlay } from "@hooks/useProcessingOverlay";
import GenericCheckbox from "@ui-components/Checkbox/GenericCheckbox";
import GenericMultiDropdown from "@ui-components/Dropdown/GenericMultiDropdown";


const API_URL = process.env.REACT_APP_API_URL || "";

type ProductList = {
    name: string;
    id: number;
};

type User = {
    name: string;
    nameDisplay: string;
    domain: string;
    hasMFA: boolean;
    Products: ProductList[];
};

interface CustomersModalCreateProps {
    setID: (id: string | null | undefined) => void;
    id?: string | null;
    fetchCustomers: () => Promise<void>;
}

export function CustomersModalCreate({ setID, id, fetchCustomers }: CustomersModalCreateProps) {
    // const tenant = useAppSelector((state) => state.tenant.id);
    const { tenantId } = useAppSelector(state => state.selection);
    const { getAccessTokenSilently } = useAuth0();
    // userData => estado que el usuario está editando en el formulario
    const [userData, setUserData] = useState<User>({
        name: "",
        nameDisplay: "",
        domain: "",
        hasMFA: false,
        Products: [],
    });

    // const [roles, setRoles] = useState<Rol[]>([]);
    const [loading, setLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);

    // Overlay para spinner
    const overlaySpinner = useProcessingOverlay(isFetching);

    const roles = [
        {
            name: 'Reflector',
            id: 1
        },
        {
            name: 'Kontrol Edge',
            id: 2
        },
        {
            name: 'CTX Hub',
            id: 3
        },
        {
            name: 'Reflector V2',
            id: 4
        },
    ]

    // Validar si los campos requeridos están llenos y, en modo Edit, si hay cambios
    function isFormValid() {
        return (
          userData.name.trim() !== "" &&
          userData.domain.trim() !== "" &&
          userData.Products.length > 0
        );
      }

    const handleSave = async () => {
        setLoading(true);
        try {
            const token = await getAccessTokenSilently();
            const endpoint = `${API_URL}/v1/tenant/create-with-hierarchy?tenantId=${tenantId}`

            const requestBody = {
                name: userData.name,
                domain: userData.domain,
                displayName: userData.nameDisplay,
                tenantTypeId: 3,
                hasMFA: userData.hasMFA,
                products: userData.Products.map((product) => product.id),
                };
            console.log(requestBody);
            await axios.post(endpoint, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setID(undefined);
            fetchCustomers();
        } catch (error: unknown) {
            const err = error as AxiosError;
            console.error("Error saving user =>", err);
            // Manejo de error con tu alerta o como gustes
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <GenericModal
                isOpen={true}
                onClose={() => setID(undefined)}
                title={"Add Customer"}
                size="lg"
            >
                <div className="grid border-t pt-5 grid-cols-2 gap-4 mb-4">
                    {/* First Name (requerido) */}
                    <GenericInput
                        label={
                            <span>
                                Name <span className="text-red-500">*</span>
                            </span>
                        }
                        value={userData.name}
                        onChange={(v) => setUserData({ ...userData, name: v })}
                    />

                    {/* Last Name (opcional) */}
                    <GenericInput
                        label="Display Name"
                        value={userData.nameDisplay}
                        onChange={(v) => setUserData({ ...userData, nameDisplay: v })}
                    />

                    {/* Email (requerido) */}
                    <GenericInput
                        label={
                            <span>
                                Domain <span className="text-red-500">*</span>
                            </span>
                        }
                        value={userData.domain}
                        onChange={(v) => setUserData({ ...userData, domain: v })}
                    />


                    {/* Products (requerido) */}
                    <div className="col-span-1">
                        <label className="text-sm font-medium">
                            Products <span className="text-red-500">*</span>
                        </label>
                        <GenericMultiDropdown
                            items={roles.map((r) => r.name)}
                            value={userData.Products.map((r) => r.name)} // Pass an array of names
                            onSelect={(selectedNames: string[]) => {
                              // Find the selected roles based on the names array
                              const selectedRoles = roles.filter((r) => selectedNames.includes(r.name));
                              setUserData({
                                ...userData,
                                Products: selectedRoles,
                              });
                            }}
                          
                            defaultLabel="Select Products"
                            widthClass="w-full"
                            maxWidthClass="max-w-[400px]"
                        />
                    </div>
                </div>

                <div className="flex justify-end gap-2">
                    <GenericButton
                        variant="secondary"
                        label="Cancel"
                        onClick={() => setID(undefined)}
                    />
                    <GenericButton
                        variant="brand"
                        label={loading ? "Saving..." : "Save"}
                        onClick={handleSave}
                        // Deshabilitado si no es válido el form o si está en loading
                        disabled={loading || !isFormValid()}
                    />
                </div>
            </GenericModal>

            {overlaySpinner}
        </>
    );
}

export default CustomersModalCreate;
